import axios from "axios";
const d = new Date();
export const API = axios.create({
  // baseURL: `http://139.135.229.31:10002/api`,
  // headers: {
  //   "Content-Type": "application/json",
  //   "wsc-timestamp": d.getTime(),
  // },
  // baseURL: `http://139.135.229.31:10002/api`,
  baseURL:
    process.env.NODE_ENV === "development"
      ? `https://ibas.s2s.ph/api`
      : "https://ibas.s2s.ph/api",
  headers: {
    "Content-Type": "application/json",
    "wsc-timestamp": d.getTime(),
  },
});

export const API2 = axios.create({
  baseURL:
    process.env.NODE_ENV === "development"
      ? `https://load.s2s.ph/api`
      : "https://load.s2s.ph/api",
  headers: {
    Authorization:
      "LOmiuDQv1VdkOZdAkdkh6Y+n8GH6TWBwqOgp5EMJ2MTCTfz73HLk33LsC8nF/EP3SI8pQ9wkiA==",
  },
});

export const payment = axios.create({
  baseURL: "https://payment.s2s.ph/api",
  headers: {
    "Content-Type": "application/json",
    "wsc-timestamp": d.getTime(),
    Authorization:
      "FFWPj+Lq8QWRAcstQF3j/f8NO88vFJYqtv/Mb3N+mP7DYjczXPdtQ5Qy3yEUQDjKJ/dfsIaSRg==",
  },
});

export const CONTACT_US = axios.create({
  baseURL: `https://csp.s2s.ph/api`,
});

export const LOAD_API = axios.create({
  baseURL:
    process.env.NODE_ENV === "development"
      ? `https://load.s2s.ph/api`
      : "https://load.s2s.ph/api",
});

export const APPLICATION_API = axios.create({
  baseURL:
    process.env.NODE_ENV === "development"
      ? `https://application.s2s.ph/api`
      : "https://application.s2s.ph/api",
  headers: {
    Authorization:
      "lLVnnPc6pxzaqxiaLt9szzILhtOH+7+6fdG4YkCO9IgesGkKrWQCUpG+6vthe2buqLfjaoAv5w==",
  },
});

export const BROKER_API = axios.create({
  baseURL:
    process.env.NODE_ENV === "development"
      ? `https://broker.s2s.ph/api`
      : "https://broker.s2s.ph/api",
  headers: {
    Authorization:
      "b6211184cd5d8cf17f988a738b90f59a93207d39b9c58260f2255cd7dfe22000",
  },
});

export const CHAT_API = axios.create({
  baseURL: `https://chat-api.s2s.ph/api`,
  headers: {
    "Content-Type": "application/json",
  },
});

export const PREPAID_API = axios.create({
  baseURL: `https://pf-wh.s2s.ph`,
  headers: {
    "Content-Type": "application/json",
  },
});
